import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProfileContext } from './contexts';

function usePaymentPeriod() {
	const profileContext = useContext(ProfileContext);
	const navigate = useNavigate();

	return (path = '/') => {
		if (profileContext.expert !== undefined) {
			if (!profileContext.fetchingExpert) {
				if (
					profileContext.expert?.paymentPeriod === null &&
					path !== '/settings'
				) {
					navigate('/settings');
				}
			}

			return true;
		}

		return false;
	};
}

export default usePaymentPeriod;
